import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Ticket from '../views/ArrowBuilds.vue'
import ListStatusPerJob from '../components/ListStatusPerJobFromFirebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/arrowbuilds',
    name: 'Ticket',
    component: Ticket
  },
  {
    path: '/jobs',
    name: 'ListStatusPerJob',
    component: ListStatusPerJob
  },
  {
    path: '/jobshash',
    name: 'ListStatusPerJob',
    component: ListStatusPerJob
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

// eslint-disable-next-line no-unused-vars
const scrollBehavior = function(to, from, savedPosition) {
  if (to.hash) {
    return {
      selector: to.hash
    }
  } else {
    return {
      x: 0,
      y: 0
    }
  }
};

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: scrollBehavior,
  base: process.env.BASE_URL,
  routes
})

export default router
